import script from "./mobileHome.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileHome.vue?vue&type=script&setup=true&lang=js"

import "./mobileHome.css?vue&type=style&index=0&id=867fb610&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-867fb610"]])

export default __exports__